import React, {FunctionComponent, Fragment} from 'react';
import Grid from '@material-ui/core/Grid/Grid';
import Typography from "@material-ui/core/Typography/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";
import blue from "@material-ui/core/colors/blue";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import './Wizard.css';

interface IWizard{
    steps: IWizardStep[]
}
interface IWizardStep {
    key:string;
    items: JSX.Element[]
}

const useStyles = makeStyles(theme => ({
    wizardStep:{
        "&:last-child": {
            "& $wizardStep__item:last-child": {
                border:'none',
                marginLeft:'1px'
            }
        }
    },
    wizardStep__index:{
        backgroundColor: blue[600],
        color:"white",
        borderRadius:'50%',
        lineHeight: 1.5,
        width:'2.3rem',
        textAlign:"center",
        padding:theme.spacing(0.66),
        marginRight:theme.spacing(3),
        marginTop:"-0.5rem"
    },
    wizardStep__item:{
        paddingLeft: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        borderLeft: "1px solid #ccc",
        position:"relative",
        "&:last-child":{
            [theme.breakpoints.up('md')]: {
                border: "none",
                marginLeft: "1px"
            }
        }
    }
}));

const Wizard:FunctionComponent<IWizard> = ({steps}) => {
    const classes = useStyles();

    return <div className="wizard">
        {
            steps.map((s, i) =>
                <Grid key={s.key} item container xs={12} md={4} classes={{root:classes.wizardStep}}>
                    <Grid item>
                        <Typography classes={{root:classes.wizardStep__index}}>{i + 1}</Typography>
                    </Grid>
                    <Grid item container xs direction="column">
                        {
                            s.items.map((item, index) =>
                                <Grid item xs classes={{root:classes.wizardStep__item}}>
                                    {item}
                                    <FontAwesomeIcon className={`wizard-step__square-icon ${index === 0 && 'wizard-step__square-icon--first'}`} icon="square"/>
                                </Grid>
                            )
                        }
                    </Grid>
                </Grid>
            )
        }
    </div>;
}

export default Wizard;
